import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import usePDFLoader from 'Hooks/usePDFLoader';

export default function ThumbnailPDF({ className, url }) {
    const canvasRef = useRef(null);
    const { pdf, isLoading } = usePDFLoader(url);

    useEffect(() => {
        if (!pdf) return;

        pdf.getPage(1).then((page) => {
            const canvas = canvasRef.current;
            if (!canvas) return;

            const viewport = page.getViewport({ scale: 1 });
            const context = canvas.getContext('2d');

            canvas.height = viewport.height;
            canvas.width = viewport.width;

            page.render({
                canvasContext: context,
                viewport,
            });
        });
    }, [pdf]);

    return <canvas ref={canvasRef} className={className} style={{ display: isLoading || !pdf ? 'none' : 'block' }} />;
}

ThumbnailPDF.propTypes = {
    url: PropTypes.string.isRequired,
    className: PropTypes.string,
};
